<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" fxLayoutAlign="space-between" style="padding: 10px 30px 30px">
      <h3>Report Letture </h3>
      <!--<app-grid-menu [addText]="'delivery.grid.new' | translate" (refreshPage)="refreshPage()" [gridFilters]="gridFilters" [filters]="filters"
        [canAdd]="canExecute(Actions.ADD, Models.CUSTOMREPORTS)" (openFilters)="openFilters()" (removeFilter)="removeFilter.emit($event)"
      ></app-grid-menu>-->
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)" row.delivery_category_item.type.tipologia {{getCellValue(row, column) }}-->
      <table mat-table [dataSource]="data"  aria-describedby="conferrals tables">
        <!--<ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef>
              {{ column  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row[column] | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>-->
        <ng-container matColumnDef="seriale">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.seriale" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.seriale}}
            </td>
        </ng-container>
        <ng-container matColumnDef="numero_letture">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.numero_letture" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.numero_letture }}
            </td>
        </ng-container>
        <ng-container matColumnDef="is_panmobil">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.is_panmobil" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-icon>
                {{ row.is_panmobil  ? "check" : "clear" }}
              </mat-icon>
            </td>
        </ng-container>
        <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.percentage"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.percentage | number : '1.2-2' }}%
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
          </td>
        </tr>
      </table>
    </div>
</div>